export const COLOR_WH = '#FFFFFF';
export const COLOR_BLACK = '#000000';
export const COLOR_GRAY = '#EFEFEF';
export const COLOR_GRAY_2 = '#E1E1E1';
export const COLOR_GRAY_3 = '#DCDCDC';
export const COLOR_GRAY_4 = '#6B6F8C';
export const COLOR_YELLOW = '#F5A11D';

export const COLOR_NEUTRAL_DARKEST = '#0C0C0C';
export const COLOR_NEUTRAL_DARK = '#181818';
export const COLOR_NEUTRAL = '#323232';
export const COLOR_NEUTRAL_MID = '#606060';
export const COLOR_NEUTRAL_LIGHT = '#C4C4C4';
export const COLOR_NEUTRAL_LIGHTEST = '#CFCFCF';
export const COLOR_NEUTRAL_ULTRALIGHT = '#F2F2F2';

export const COLOR_PRIMARY = '#F2C560';
export const COLOR_PRIMARY_MID = '#F6D784';

export const COLOR_GRADIENT = 'linear-gradient(90.22deg, #F7D784 2.73%, #D6B358 104.38%)';
export const COLOR_GRADIENT_BG = 'linear-gradient(180deg, #F4F5F7 12.83%, #F8D781 100%)';

export const COLOR_POSITIVE_DARK = '#16A249';
export const COLOR_POSITIVE = '#22C55E';
export const COLOR_POSITIVE_MID = '#4ADE80';
export const COLOR_POSITIVE_LIGHT = '#85EFAC';

export const COLOR_NEGATIVE_DARK = '#C73D3D';
export const COLOR_NEGATIVE = '#EF4444';
export const COLOR_NEGATIVE_MID = '#F26666';
export const COLOR_NEGATIVE_LIGHT = '#FDA4AF';

export const COLOR_ACCENT = '#604290';
export const COLOR_PURPURE = '#604290';
export const COLOR_PURPLE = '#985CF7';
export const COLOR_STROKE = '#5C5C5C';
export const COLOR_TEXT_GRAY = '#ffffffb3';
export const COLOR_CARD = '#d9d9d91a';
export const COLOR_BUTTON = '#ffffff1a';
export const COLOR_RED = '#FF0000';
